<template>
  <div class="row">
    <div class="col-sm-7 left-column">
      <div class="login__box">
        <div class="login__logo">
          <img src="@/assets/trinitas-logo.png" height="100">
        </div>
        <form class="login-form" @submit.prevent="signin">
          <div class="form-group">
            <input type="email" placeholder="email" v-model="email" class="form-control"/>
          </div>
          <div class="form-group">
            <input type="password" placeholder="password" v-model="password" class="form-control"/>
          </div>
          <div class="form-group row login__remember-box">
            <div class="col m--align-left">
              <label class="m-checkbox m-checkbox--focus">
                <input name="remember" type="checkbox" ng-reflect-name="remember" ng-reflect-model="true" class="ng-untouched ng-pristine ng-valid">
                Recordarme
                <span></span>
              </label>
            </div>
            <div class="col m--align-right">
              <a class="m-link" href="javascript:;" id="m_login_forget_password">
                ¿Olvidaste tu contraseña?
              </a>
            </div>
          </div>
          <div class="form-group login__btn-container">
            <button class="login__btn">Iniciar Sesión</button>
          </div>
        </form>
      </div>
    </div>
    <div class="col-sm-5 right-column" style="background-color: #3D89DB">
      <div class="m-grid__item m-grid__item--middle">
        <h3 class="login__welcome">
          EXPERTOS EN EL SECTOR FINANCIERO
        </h3>
        <h1 _ngcontent-c1="" style="color: white;">Administración de Acreedores</h1>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      email: '',
      password: ''
    }
  },
  methods: {
    signin () {
      this.$store.dispatch({
        type: 'signin',
        email: this.email,
        password: this.password
      }).then(res => {
        if (res) {
          this.$toasted.show('Usuario y contraseña correctos, bienvenido', {
            type: 'success',
            icon: 'error_outline',
            duration: 3000,
            fullWidth: true,
            position: 'bottom-center',
            fitToScreen: true
          })
          this.email = ''
          this.password = ''
          this.platform = this.$store.getters.getPlatform
          if (this.platform == 'ahorros') {
            this.$router.push('colaborators')
          } else {
            this.$router.push('dashboard')
          }
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import "src/scss/variables";
  @import "src/scss/login";
</style>



// WEBPACK FOOTER //
// src/components/Login.vue